export default function detectAndroidVersion() {
    var _a;
    if (typeof window === "undefined" || ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) == null) {
        return 0;
    }
    const ua = window.navigator.userAgent;
    if (/Android/.test(ua)) {
        const matches = / Android (\d\d)_/.exec(ua);
        if (matches != null && matches.length > 1) {
            return parseInt(matches[1]);
        }
        return 10;
    }
    return 0;
}
